<app-servers [servers]="servers" (refreshServers)="refreshServerList()"></app-servers>